import React, { Fragment, useContext, useCallback } from 'react';
import * as S from './style';
import { SpaceDiv, BtnImg, Banner } from 'components';
import { useHistory } from 'react-router-dom';
import { isIE } from 'react-device-detect';

import { apiPartnerLogout } from 'api/ZimssaAPI';
import { PartnerAuthState } from 'stores/PartnerAuthStore';
import * as PAGE_URL from 'router/PageUrl';
import {
  BUTTON_LOGIN,
  BUTTON_LOGOUT,
  BUTTON_SIGNUP_1,
} from 'commons/ZimssaString';
import ScrollToTop from 'hooks/ScrollToTop';
import { showModal } from '../../../commons/utils/showModal';

import { ReactComponent as LeftArrow } from 'assets/img/common/ic_left_arrow_gray.svg';

export interface Props {
  isBackBtn?: boolean;
}

function Header({ isBackBtn }: Props): React.ReactElement {
  const history = useHistory();

  const { isLogin, name } = useContext(PartnerAuthState);
  const path = window.location.pathname;
  const isMain = path === PAGE_URL.MAIN.path;

  const handleLogout = async () => {
    const confirmed = await showModal({
      title: '로그아웃 하시겠습니까?',
    });
    if (!confirmed) return;

    apiPartnerLogout().then((response) => {
      const { result } = response;
      if (result === 'success') {
        localStorage.removeItem('access-token');
        window.location.href = '/';
      }
    });
  };

  const onClickBackCallback = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      history.goBack();
    },
    [history]
  );

  return (
    <Fragment>
      <ScrollToTop />
      <S.HeaderContainer isMain={isMain}>
        {isIE && (
          <Banner isError={true}>
            <p>
              파트너 페이지는 <b>크롬 브라우저</b>에서 정상 구동됩니다.
              <b>크롬 브라우저</b>에서 다시 접속해 보세요.
            </p>
          </Banner>
        )}
        <S.HeaderWrapper>
          {isBackBtn ? (
            <S.BtnBack onClick={onClickBackCallback}>
              <LeftArrow />
            </S.BtnBack>
          ) : (
            <BtnImg
              {...{
                width: 70,
                height: 34,
                href: PAGE_URL.MAIN.path,
                backGroundImg: isMain
                  ? `${process.env.REACT_APP_S3_URL}/partner-web/images/btn_logo_white.png`
                  : `${process.env.REACT_APP_S3_URL}/partner-web/images/btn_logo_black.png`,
                backGroundColor: isMain
                  ? 'gray_opacity_800'
                  : 'gray_opacity_50',
                radius: 0,
              }}
            />
          )}
          <S.BtnContainer>
            {(() => {
              if (isLogin) {
                return (
                  <Fragment>
                    <S.NameLabelWrapper>
                      <b>{name}</b> 님!
                    </S.NameLabelWrapper>
                    <S.BtnLogOut onClick={handleLogout}>
                      {BUTTON_LOGOUT}
                    </S.BtnLogOut>
                  </Fragment>
                );
              } else {
                if (path === PAGE_URL.LOGIN.path) {
                  return (
                    <S.BtnSignUp href={PAGE_URL.SIGNUP.path}>
                      {BUTTON_SIGNUP_1}
                    </S.BtnSignUp>
                  );
                } else if (path === PAGE_URL.SIGNUP.path) {
                  return (
                    <S.BtnLogIn href={PAGE_URL.LOGIN.path}>
                      {BUTTON_LOGIN}
                    </S.BtnLogIn>
                  );
                } else {
                  return (
                    <Fragment>
                      <S.BtnLogIn href={PAGE_URL.LOGIN.path}>
                        {BUTTON_LOGIN}
                      </S.BtnLogIn>
                      <S.BtnSignUp href={PAGE_URL.SIGNUP.path}>
                        {BUTTON_SIGNUP_1}
                      </S.BtnSignUp>
                    </Fragment>
                  );
                }
              }
            })()}
          </S.BtnContainer>
        </S.HeaderWrapper>
      </S.HeaderContainer>
      {isMain ? null : <SpaceDiv />}
    </Fragment>
  );
}

export default Header;
